{
  "app": {
    "name": "3ojo"
  },
  "nav": {
    "admin": "Admin",
    "arcana": "Arcanos",
    "readings": "Tiradas",
    "horoscope": "Horóscopo",
    "dreams": "Sueños",
    "account": "Cuenta",
    "settings": "Ajustes",
    "back": "Atrás",
    "home": "Inicio"
  },
  "common": {
    "continue": "Continuar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "save": "Guardar",
    "saving": "Guardando…",
    "saved": "Guardado",
    "loading": "Cargando…",
    "retry": "Reintentar",
    "signIn": "Entrar",
    "signOut": "Salir",
    "comingSoon": "Próximamente",
    "upgrade": "Mejora para acceder",
    "offline": "Estás sin conexión",
    "error": "Algo salió mal"
  },
  "home": {
    "actions": "Empezar",
    "browseArcana": "Explorar Arcanos",
    "newReading": "Nueva tirada",
    "allReadings": "Ver todas",
    "todaysHoroscope": "Horóscopo de hoy",
    "cardOfTheDay": "Carta del día",
    "learnMore": "Saber más",
    "readFullHoroscope": "Leer el horóscopo completo",
    "openHoroscope": "Abrir el horóscopo",
    "news": "Novedades",
    "newsKind": {
      "update": "Actualización",
      "post": "Blog",
      "callout": "Participa"
    }
  },
  "decks": {
    "title": "Elige una baraja",
    "subtitle": "Los significados están escritos sobre la Rider-Waite-Smith. Las demás barajas la toman prestada o se apartan de ella.",
    "cardCount": "{count} cartas",
    "selected": "Elegida"
  },
  "arcana": {
    "searchPlaceholder": "Filtra cartas — prueba \"3\", \"tres\", \"luna\"",
    "searchHint": "La búsqueda funciona en español e inglés, sea cual sea tu idioma.",
    "noResults": "Ninguna carta coincide con \"{query}\".",
    "clearSearch": "Limpiar",
    "resultCount": "{count} de 78",
    "reversed": "Invertida",
    "keywords": "Claves",
    "meaning": "Significado",
    "reversedMeaning": "Invertida",
    "inDepth": "En profundidad",
    "unlockInDepth": "Desbloquea el significado en profundidad",
    "unlockBlurb": "Veinte años de notas sobre esta carta, más allá del resumen de arriba.",
    "yourNotes": "Tus notas",
    "addNotes": "Añade tus propias notas",
    "notesPlaceholder": "Qué significa esta carta para ti, cuándo apareció, qué notaste…",
    "notesPending": "Sin conexión. Se guardará al reconectar",
    "notesSynced": "Guardado",
    "alternateArt": "Otras versiones",
    "seeAlso": "Ver también",
    "translationPending": "El texto largo en español aún se está escribiendo. Por ahora se muestra en inglés.",
    "translationPendingShort": "Texto en inglés"
  },
  "reading": {
    "title": "Tiradas",
    "subtitle": "Saca una carta, o tres, o cinco.",
    "spread1": "Una carta",
    "spread3": "Tres cartas",
    "spread5": "Cinco cartas",
    "spread1Blurb": "Un solo foco.",
    "spread3Blurb": "Qué trajo esto, dónde estás, hacia dónde va.",
    "spread5Blurb": "El cuadro completo, con lo que ayuda y lo que estorba.",
    "questionLabel": "¿Qué traes en mente?",
    "questionPlaceholder": "Una pregunta, un tema, o nada",
    "questionOptional": "Opcional",
    "draw": "Sacar",
    "drawing": "Sacando…",
    "consulting": "El Oráculo está leyendo…",
    "synthesis": "El Oráculo",
    "newReading": "Nueva tirada",
    "history": "Tiradas anteriores",
    "noHistory": "Aún no hay tiradas.",
    "lockedCard": "Desbloquea esta carta",
    "lockedBlurb": "Desbloquea la 3.ª carta y las perspectivas personalizadas del Oráculo.",
    "dailyDoneTitle": "La lectura de hoy está hecha",
    "dailyLimit": "Ya tuviste tu lectura de tres cartas con el Oráculo de hoy. Vuelve mañana, o mejora tu plan para lecturas ilimitadas, todas las tiradas y perspectivas más profundas.",
    "upgradeForLayouts": "Mejora tu plan para desbloquear más tiradas",
    "upgradeNudge": "Esta es la versión corta. Mejorar desbloquea las tiradas de una y cinco cartas, lecturas más largas del Oráculo y el significado completo de cada carta.",
    "aiOffline": "El Oráculo necesita conexión. Tus cartas y sus significados siguen aquí.",
    "quotaExceeded": "Ya usaste el cupo del Oráculo de este mes. Los significados siguen funcionando igual.",
    "tapToReveal": "Toca una carta para voltearla.",
    "tapToOpen": "Toca una carta volteada para leerla completa.",
    "turnCard": "Voltear la carta {n}: {position}",
    "openCard": "Leer {name}",
    "learnMore": "Aprende más sobre esta carta en el estudio de los Arcanos",
    "askOracle": "Pregunta al Oráculo",
    "askAgain": "Pregunta otra vez al Oráculo",
    "contextLabel": "¿Algún contexto adicional?",
    "contextPlaceholder": "Algo que haya surgido desde que sacaste las cartas",
    "revealFirst": "Voltea una carta y luego pregunta al Oráculo.",
    "revealMore": "Voltea otra carta para preguntar otra vez al Oráculo.",
    "oracleDone": "Todas las cartas están volteadas y leídas.",
    "revealedOf": "{count} de {total} cartas",
    "closeCard": "Cerrar",
    "backToReading": "Volver a la tirada",
    "positions": {
      "1": ["La carta"],
      "3": ["Lo que trajo esto", "Dónde estás", "Hacia dónde va"],
      "5": ["El centro del asunto", "Lo que hay detrás", "Lo que estorba", "Lo que ayuda", "Hacia dónde va"]
    }
  },
  "horoscope": {
    "title": "Horóscopo",
    "readingFor": "Lectura del {date}",
    "notGenerated": "Aún no se generó ningún horóscopo.",
    "notGeneratedBlurb": "Estos se generan según un horario, no bajo demanda — vuelve pronto.",
    "loadError": "No se pudo cargar el horóscopo.",
    "changeSign": "Cambia tu signo en Ajustes",
    "otherSigns": "Otros signos"
  },
  "dreams": {
    "title": "Interpretación de sueños",
    "subtitle": "Cuéntanos los detalles de tu sueño y te ayudaremos a entenderlo.",
    "inputLabel": "Tu sueño",
    "inputPlaceholder": "Cuéntanos los detalles de tu sueño y te ayudaremos a entenderlo",
    "submitHint": "Ctrl+Enter (o el botón) para enviar. Enter inicia una nueva línea.",
    "submit": "Interpretar",
    "comingSoon": "Próximamente: interpretación de sueños mejorada",
    "interpretation": "Interpretación",
    "interpreting": "Consultando al Oráculo…",
    "upgradeRequired": "Actualiza a un plan de pago para acceder",
    "aboutTitle": "Cómo funciona",
    "aboutBody": "El Oráculo lee tu sueño desde una perspectiva junguiana — arquetipos, la sombra y el inconsciente colectivo — como disparador de reflexión, no como predicción."
  },
  "auth": {
    "title": "Iniciar sesión",
    "blurb": "Ya sea tu primera vez o no, ingresa tu correo y te enviaremos un token de acceso.",
    "emailLabel": "Correo",
    "emailPlaceholder": "tu{'@'}ejemplo.com",
    "sendCode": "Envíame un código",
    "sending": "Enviando…",
    "codeLabel": "Código de seis dígitos",
    "codeSent": "Si esa dirección recibe correo, el código va en camino.",
    "verify": "Entrar",
    "verifying": "Entrando…",
    "resend": "Enviar otro código",
    "wrongCode": "Ese código no es correcto.",
    "expired": "Ese código caducó. Pide uno nuevo.",
    "checkEmail": "Revisa tu correo",
    "differentEmail": "Usar otra dirección",
    "whatIs": "¿Qué es 3ojo?"
  },
  "account": {
    "title": "Cuenta",
    "signedInAs": "Sesión de",
    "tier": "Plan",
    "tiers": {
      "guest": "Invitado",
      "free": "Intuitivo",
      "mystic": "Mystic",
      "oracle": "Oracle",
      "gifted": "Regalado"
    },
    "tierBlurb": {
      "guest": "Navegando sin cuenta. Los significados y una carta diaria son tuyos.",
      "free": "Significados, claves y una lectura de tres cartas al día con una nota breve del Oráculo.",
      "mystic": "La app completa, con cobro mensual.",
      "oracle": "La app completa, con un solo pago. Gracias por ser de los primeros en apoyarnos.",
      "gifted": "La app completa, de regalo."
    },
    "upgradeTitle": "Consigue la app completa",
    "upgradeBlurb": "Significados en profundidad, tus propias notas, tiradas de cinco cartas y el Oráculo.",
    "planMystic": "$3.33 / mes",
    "planMysticDetail": "$2.99 más impuestos",
    "planOracle": "$7.99 una vez",
    "planOracleDetail": "Acceso de por vida · pago único, más impuestos",
    "earlyAccess": "Por tiempo limitado. Este es el precio más bajo que ofreceremos jamás: Oracle nunca costará menos. Es una garantía de acceso anticipado para quienes nos apoyan primero.",
    "redirecting": "Llevándote al pago…",
    "choosePlan": "Elegir",
    "cancelSubscription": "Cancelar suscripción",
    "cancelWarning": "Cancelar termina el acceso de inmediato, no a fin de mes.",
    "cancelled": "Suscripción cancelada.",
    "usage": "Uso del Oráculo este mes",
    "usageOf": "{used} de {budget} tokens",
    "billingUnavailable": "Los pagos aún no están configurados en este servidor.",
    "signOutNote": "Siempre puedes volver a entrar con tu correo."
  },
  "settings": {
    "title": "Ajustes",
    "language": "Idioma",
    "languageBlurb": "El filtro de cartas funciona en ambos idiomas, elijas el que elijas.",
    "switchLanguage": "Cambiar a {language}",
    "defaultDeck": "Baraja por defecto",
    "zodiacSign": "Tu signo",
    "zodiacSignBlurb": "Define qué signo se muestra en la pestaña Horóscopo.",
    "reversals": "Cartas invertidas",
    "reversalsOn": "Incluir cartas invertidas",
    "reversalsLockedBlurb": "Las cartas invertidas están siempre activas en las cuentas Intuitivas.",
    "reversalFrequency": "Con qué frecuencia",
    "frequency": {
      "very-low": "Muy baja (1 de 8)",
      "low": "Baja (1 de 4)",
      "natural": "Natural (1 de 2)"
    },
    "quickDraw": "Saltar el paso de la pregunta",
    "quickDrawBlurb": "Ir directo a las cartas.",
    "shareInsights": "Compartir tiradas para mejorar 3ojo",
    "shareInsightsBlurb": "Desactivado por defecto. Tus tiradas siempre se guardan en tu cuenta; esto decide si además pueden usarse para mejorar 3ojo.",
    "offline": "Sin conexión",
    "downloadArt": "Guardar todas las cartas para uso sin conexión",
    "downloadArtBlurb": "Unos 5MB. Los significados ya funcionan sin conexión.",
    "downloading": "Guardando {done} de {total}…",
    "downloaded": "Todas las cartas están disponibles sin conexión.",
    "update": "Actualización disponible",
    "updateNow": "Recarga para actualizar"
  },
  "install": {
    "title": "Instalar 3ojo",
    "blurb": "Añádela a tu pantalla de inicio para usarla sin conexión.",
    "action": "Instalar"
  }
}
